/* eslint-disable no-console */
/* eslint-disable react/forbid-prop-types */
import React, { useState, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import Topbar from './topbar/Topbar';
import Sidebar from './sidebar/Sidebar';

import { changeThemeToDark, changeThemeToLight } from '../../redux/actions/themeActions';
import { changeMobileSidebarVisibility, changeSidebarVisibility } from '../../redux/actions/sidebarActions';
import { ThemeProps } from '../../shared/prop-types/ReducerProps';
import { Loading } from '../../helpers/utils';

const Layout = (props) => {
  const {
    dispatch, sidebar, theme, user,
  } = props;
  const layoutClass = classNames({
    layout: true,
    'layout--collapse': sidebar.collapse,
    zIndex: 100,
  });

  const [color, setColor] = useState({
    r: 110, g: 140, b: 160, a: 0.3,
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (user && user.type) {
      if (user.themeColor) {
        setColor(user.themeColor);
      }
      setLoading(false);
    }
  }, [user]);

  const changeToDark = () => {
    dispatch(changeThemeToDark());
  };

  const changeToLight = () => {
    dispatch(changeThemeToLight());
  };

  return (
    <div className={layoutClass}>
      {loading === false
        ? (
          <>
            <Topbar
              changeMobileSidebarVisibility={() => dispatch(changeSidebarVisibility())}
              changeSidebarVisibility={() => dispatch(changeSidebarVisibility())}
              changeToDark={changeToDark}
              changeToLight={changeToLight}
              theme={theme}
              color={color}
              setColor={setColor}
            />
            <Sidebar
              sidebar={sidebar}
              user={user}
              changeToDark={changeToDark}
              changeToLight={changeToLight}
              changeSidebarVisibility={() => dispatch(changeSidebarVisibility())}
              changeMobileSidebarVisibility={changeMobileSidebarVisibility}
              color={color}
            />
          </>
        )
        : <Loading />}
    </div>
  );
};

Layout.propTypes = {
  dispatch: PropTypes.func.isRequired,
  sidebar: ThemeProps.isRequired,
  theme: ThemeProps.isRequired,
  user: PropTypes.any.isRequired,
};

function mapState(state) {
  let { user } = state.user;
  const { sidebar } = state;
  const { topbar } = state;
  const { theme } = state;
  if (user === undefined) {
    user = {};
  }
  return {
    user, sidebar, topbar, theme,
  };
}

export default withRouter(connect(mapState)(Layout));
